import { Logo } from '@/components/Logo';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { SignUpForm } from '@/components/auth/SignUpForm';
const SignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber || '';
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 animate-fade-in">
      <div className="w-full max-w-sm flex flex-col items-center">
        <Logo variant="dark" />
        <h1 className="text-2xl font-bold mt-8 mb-2 text-center py-[32px]">Create your account</h1>
        
        
        <SignUpForm onLoading={setIsLoading} initialPhoneNumber={phoneNumber} />
        
        <div className="mt-6 text-center">
          <p className="text-gray-600">
            <Link to="/login" className="text-primary font-medium">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default SignUp;